import { render, staticRenderFns } from "./hd-category-nav.vue?vue&type=template&id=4d7e66b7&scoped=true"
import script from "./hd-category-nav.vue?vue&type=script&lang=js"
export * from "./hd-category-nav.vue?vue&type=script&lang=js"
import style0 from "./hd-category-nav.vue?vue&type=style&index=0&id=4d7e66b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e66b7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})


/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
